'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _utilsSkin = require('../utils/skin');

var _utilsSkin2 = _interopRequireDefault(_utilsSkin);

var _beatportServiceCharts_service = require('./beatport/service/charts_service');

var _beatportServiceCharts_service2 = _interopRequireDefault(_beatportServiceCharts_service);

var _beatportServiceGenres_service = require('./beatport/service/genres_service');

var _beatportServiceGenres_service2 = _interopRequireDefault(_beatportServiceGenres_service);

var _youtubeServiceYoutube_sdk = require('./youtube/service/youtube_sdk');

var _youtubeServiceYoutube_sdk2 = _interopRequireDefault(_youtubeServiceYoutube_sdk);

var _youtubeServiceYoutube = require('./youtube/service/youtube');

var _youtubeServiceYoutube2 = _interopRequireDefault(_youtubeServiceYoutube);

var moduleName = 'app.services';

_angular2['default'].module(moduleName, []).service('SkinService', _utilsSkin2['default']).service('BPChartService', _beatportServiceCharts_service2['default']).service('BPGenresService', _beatportServiceGenres_service2['default']).service('YoutubeSDKService', _youtubeServiceYoutube_sdk2['default']).service('YoutubeService', _youtubeServiceYoutube2['default']);

exports['default'] = moduleName;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/app.services.js
 ** module id = 29
 ** module chunks = 0
 **/